const sanitizeDirectoryStructure = (structure = {}) => {
  if (!structure || typeof structure !== "object") {
    return {};
  }

  return Object.entries(structure).reduce((acc, [key, value]) => {
    const sanitizedKey = typeof key === "string" ? key.replace(/^\//, "") : key;
    if (value && typeof value === "object") {
      acc[sanitizedKey] = { ...value };
    } else {
      acc[sanitizedKey] = value;
    }
    return acc;
  }, {});
};

export default sanitizeDirectoryStructure;

